import Decimal from './utils/break_eternity.js';
export { Decimal };